import React, { useState, useEffect } from "react";
import { compose, withHandlers, withState } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from '@material-ui/core/styles';
import {
  PRT_DETAIL_ACTIONS,
  getCohortData,
  // getArmCohortData,
  matchBoxSave,
  syncCohorts,
  getCohortsHistory,
  getStrataHistory,
  getProtocolDetails
} from "actions/protocols/protocoldetail";
import { getOpenSetup } from 'actions/protocols/opensetup';
import { openModal } from "actions/common"
import { withAppContext } from "@ctsu/loader";
import { bindLogger } from "helpers/BindLogger";
import { BoolToString, CTSUCardActions } from "components";
import _ from 'lodash';
import { FasRedoAlt } from "assets/icons";
import { RenderEditable, RenderElement, RenderControl } from "components/RenderHelpers";
import { MUISelect, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { ListItem, ListItemText, Grid } from '@material-ui/core';
import { FormViewContent } from 'components/FormViewContent';
import * as selectors from "selectors";
import { openConfirmation } from 'helpers/Confirmation';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import { CohortsData } from "appconstants/ProtocolConstants";
import atoms from "ctsutheme/components/atoms";
import { Cohorts } from "./Cohorts";
// import CohortsArmGrid from "./CohortsArmManagement";
// import ArmsGrid from "./Arms";
import { Strata } from "./Strata";

const { Divider } = atoms;

const lSelector = selectors.createLoadingSelector([
  PRT_DETAIL_ACTIONS.GET_COHORTS,
  PRT_DETAIL_ACTIONS.GET_ARM_COHORTS,
  PRT_DETAIL_ACTIONS.GET_STRATA
]);
const eSelector = selectors.createErrorMessageSelector([
  PRT_DETAIL_ACTIONS.GET_COHORTS,
  PRT_DETAIL_ACTIONS.GET_ARM_COHORTS,
  PRT_DETAIL_ACTIONS.GET_STRATA
]);

const { Typography, IconButton, Tooltip } = atoms;

const styles = theme => ({
  editable: {
    width: 100
  },
  matchboxContainer: {
    marginTop: '-0.3em'
  },
  internalMatchBox: {
    overflowWrap: 'anywhere',
    overflow: 'hidden'
  }
});

const OPTIONS = [
  { label: 'OPEN', value: 'OPEN' },
  { label: 'CLOSED', value: 'CLOSED' },
  { label: 'SUSPENDED', value: 'SUSPENDED' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'READY', value: 'READY' }
];

const filterStatus = (subList) => _.filter(OPTIONS, item => (subList.indexOf(item.value) > -1) && item);

const loadStatusRecords = currentStatus => {
  let resultSet = [];
  switch (currentStatus) {
    case 'CLOSED': {
      const subList = ['CLOSED'];
      resultSet = filterStatus(subList);
      return resultSet;
    }
    case 'OPEN':
    case 'SUSPENDED': {
      const subList = ['SUSPENDED', 'OPEN', 'CLOSED'];
      resultSet = filterStatus(subList);
      return resultSet;
    }
    case 'READY': {
      const subList = ['READY', 'OPEN', 'CLOSED'];
      resultSet = filterStatus(subList);
      return resultSet;
    }
    case 'PENDING':
    default:
      return OPTIONS;
  }
}

const MatchBoxInfo = (props) => {
  const {
    isCohortserror,
    // isCohortsarmerror,
    protocolNumber,
    isMatchboxStudy,
    isCohortsloading,
    // isCohortsarmloading,
    isStrataloading,
    isStrataerror,
    getCohort,
    // gestArmCohort,
    onGetOpenSetupData,
    context,
    loadCohortsHistory,
    loadStrataHistory,
    onOpenModal,
    handleChange,
    classes,
    toggleMatchBox,
    matchBoxFlag,
    setData,
    data,
    saveMatchBox,
    cohortSync,
    clearMatchBoxFields,
    isLoadingPrtDetails,
    iserrorPrtDetails,
    CanUserEditMatchBox,
    CanUserAuditCohorts,
    CanUserSyncCohorts,
    CanUserEditCohorts,
    // CanUserAccessInfo,
    grpProtStatus,
    isTreatment,
    closeMatchBox
    // openSetupInfo
  } = props;

  const [highlightObj, sethighlightObj] = useState({ highlightRow: 0 });
  const [highlightStrataObj, setHighlightStrataObj] = useState({ highlightRow: 0 });
  // const [highlightArmObj, setHighlightArmObj] = useState({ highlightRow: 0 });
  const [strataData, setStrataData] = useState([]);
  const [cohort, setCohort] = useState({});
  // const [selectedCohort, setSelectedCohort] = useState(null);
  // const [armData, setArmData] = useState([]);

  // const cohortData = useSelector(state => state.prtDetails.cohortsArmData);

  // const useStyles = makeStyles(theme => ({
  //   internalMatchBox: {
  //     overflowWrap: 'anywhere',
  //     overflow: 'hidden'
  //   }
  // }));

  const matchBoxClasses = styles();
  // useEffect(() => {
  //   if ((openSetupInfo && openSetupInfo.openConfig?.isCohortArmManagement)&& (!_.isEmpty(protocolNumber))) {
  //     bindLogger(getArmCohort, context)(protocolNumber)
  //   }
  // }, [protocolNumber, getArmCohort, openSetupInfo])
  
  useEffect(() => {
    if (!_.isEmpty(protocolNumber)) {
      bindLogger(getCohort, context)(protocolNumber)
      bindLogger(onGetOpenSetupData, context)(protocolNumber);
    }
  }, [protocolNumber, getCohort, onGetOpenSetupData, context]);

  useEffect(() => {
    if (isMatchboxStudy) {
      setData(isMatchboxStudy);
    }
  }, [isMatchboxStudy, setData]);

  const statusArr = ['In Review', 'Approval on Hold', 'Approved', 'Pre-activation', 'Temporarily Closed to Accrual'];

  const checkStatus = () => (statusArr.indexOf(grpProtStatus) === -1) && CanUserEditCohorts;

  const onStrataRowClick = (row, index) => {
    if (index > 0) {
      setHighlightStrataObj({ highlightRow: index });
    }
  }
  const onStratadataload = res => {
    if (res.data.length > 0) {
      onStrataRowClick(res.data[0], 0)
    }
  }

  // const onArmRowClick = (row, index) => {
  //   if (index > 0) {
  //     setHighlightArmObj({ highlightRow: index });
  //   }
  // }
  // const onArmdataload = res => {
  //   if (res.data.length > 0) {
  //     onArmRowClick(res.data[0], 0)
  //   }
  // }
  const onRowClick = (row, index) => {
    if (index >= 0) {
      sethighlightObj({ highlightRow: index });
      setStrataData(row.stratums);
      setCohort(row);
    }
    // if ((openSetupInfo && openSetupInfo.openConfig?.isCohortArmManagement) && (index >= 0)) {
    //   setHighlightArmObj({ highlightRow: index });
    //   // setArmData(row.armsList); // replace armsList with actual
    //   // setArmData(CohortsArmData[0].armsList);
    //   setSelectedCohort(row);
    // }
  }
  const onLoad = (response) => {
    if (response.data.length > 0) {
      onRowClick(response.data[0], 0);
    }
  }

  return (
    <>
      <RenderControl
        isLoading={isLoadingPrtDetails}
        iserror={iserrorPrtDetails}
        compName="MATCHBox Information"
        permission
      >
        <Grid container alignItems="center" spacing={4}>
          <Grid
            item
            xs={6}
          >
            <RenderEditable
              title="MATCHBox Information"
              state={matchBoxFlag}
              editable={CanUserEditMatchBox}
              setState={toggleMatchBox}
              subHeaderItems={
                <RenderElement access={CanUserSyncCohorts}>
                  <Tooltip
                    tooltipplacementbottom="true"
                    title="Sync Matchbox"
                    aria-label="Sync Matchbox"
                    style={{ display: "inline-flex" }}
                  >
                    <Typography component="span" inline link icon>
                      <IconButton
                        aria-label="Sync Matchbox"
                        data-id="refreshMatchBox"
                        color="inherit"
                        onClick={cohortSync}
                      >
                        <FasRedoAlt />
                      </IconButton>
                    </Typography>
                  </Tooltip>
                </RenderElement>
              }>
              <RenderElement access={!matchBoxFlag}>
                <FormViewContent
                  name="isMatchboxStudy"
                  primaryText="MATCHBox Protocol?"
                  secondaryClassName={matchBoxClasses.internalCommentsContent}
                  secondaryText={(<BoolToString boolValue={data} />)}
                />
              </RenderElement>
              <RenderElement access={matchBoxFlag}>
                <ValidatorForm onSubmit={saveMatchBox}>
                  <FormViewContent
                    primaryText="MATCHBox Protocol?"
                    secondaryText={(
                      <MUISelect
                        title=" MATCHBox Protocol"
                        value={data === true}
                        name="isMatchboxStudy "
                        className={classes.editable}
                        onChange={handleChange}
                      >
                        <ListItem button value key="isMatchboxStudyYes">
                          <ListItemText primary="Yes" />
                        </ListItem>
                        <ListItem button value={false} key="isMatchboxStudyNo">
                          <ListItemText primary="No" />
                        </ListItem>
                      </MUISelect>
                    )} />
                  <Divider />
                  <CTSUCardActions
                    clearClick={clearMatchBoxFields}
                    cancelClick={closeMatchBox}
                    disabled={data === isMatchboxStudy}
                  />
                </ValidatorForm>
              </RenderElement>
            </RenderEditable>
          </Grid>
        </Grid>
        <RenderElement access={isMatchboxStudy === true && isTreatment === true}>
          <RenderControl
            isLoading={isCohortsloading}
            iserror={isCohortserror}
            compName="Cohorts"
            title="Cohorts"
            permission={CanUserAuditCohorts}
            // permission={CanUserAuditCohorts && cohortArm-flase}
          >
            <Cohorts
              data={CohortsData}
              loadStatusRecords={loadStatusRecords}
              highlightObj={highlightObj}
              rowClick={onRowClick}
              onLoad={onLoad}
              setHighlighted={sethighlightObj}
              loadHistory={loadCohortsHistory}
              onOpenModal={onOpenModal}
              CanUserEditCohorts={checkStatus()}
            />
            </RenderControl>
          <RenderControl
            isLoading={isStrataloading}
            iserror={isStrataerror}
            title={`Strata for Cohort ${cohort.cohortName}`}
            compName="Strata"
            permission={CanUserAuditCohorts}
          >
            <Strata
              data={strataData}
              cohort={cohort}
              loadStatusRecords={loadStatusRecords}
              loadHistory={loadStrataHistory}
              highlightObj={highlightStrataObj}
              setHighlighted={setHighlightStrataObj}
              onLoad={onStratadataload}
              rowClick={onStrataRowClick}
              onOpenModal={onOpenModal}
              CanUserEditStrata={checkStatus()}
            />
          </RenderControl>
        </RenderElement>
      </RenderControl>
        {/* <RenderElement access={openSetupInfo && openSetupInfo.openConfig?.isCohortArmManagement}>
        <RenderControl
          isLoading={isCohortsarmloading}
          iserror={isCohortsarmerror}
          compName="Cohorts"
          title="Cohorts"
          permission={CanUserAccessInfo}
          >
            <CohortsArmGrid
              data={CohortsArmData}
              cohortData={cohortData}
              loadStatusRecords={loadStatusRecords}
              highlightObj={highlightObj}
              rowClick={onRowClick}
              onLoad={onLoad}
              setHighlighted={sethighlightObj}
              loadHistory={loadCohortsHistory}
              onOpenModal={onOpenModal}
              // CanUserEditCohorts={checkStatus()}
            />
        </RenderControl>
        <RenderControl
            isLoading={isStrataloading}
            iserror={isStrataerror}
            title={`Arms for Cohort ${cohort.cohortName}`}
            compName="Arms"
            permission={CanUserAuditCohorts}
          >
            <RenderElement access={cohortData?.length>0}>
              <ArmsGrid
                data={selectedCohort?.arms}
                selectedCohort={selectedCohort}
                setSelectedCohort={setSelectedCohort}
                loadStatusRecords={loadStatusRecords}
                loadHistory={loadStrataHistory}
                highlightObj={highlightArmObj}
                setHighlighted={setHighlightArmObj}
                onLoad={onArmdataload}
                rowClick={onArmRowClick}
                onOpenModal={onOpenModal}
                // CanUserEditStrata={checkStatus()}
              />
            </RenderElement>
          </RenderControl>
      </RenderElement> */}
    </>
  )
};

const withConnectState = connect(
  (state, ownProps) => ({
    prtInfo: state.prtDetails.prtInfo,
    isCohortsloading: lSelector(state),
    isCohortserror: eSelector(state),
    isCohortsarmloading: lSelector(state),
    isCohortsarmerror: eSelector(state),
    isStrataloading: lSelector(state),
    isStrataerror: eSelector(state),
    openSetupInfo: state.openData.openData,
    isLoadingPrtDetails: selectors.lSelectorGetProtDetails(state),
    iserrorPrtDetails: selectors.eSelectorGetProtDetails(state)
  }),
  (dispatch) =>
    bindActionCreators(
      {
        getCohort: getCohortData,
        // getArmCohort: getArmCohortData,
        onGetOpenSetupData: getOpenSetup,
        onSaveMatchBox: matchBoxSave,
        onSyncCohorts: syncCohorts,
        getCohHist: getCohortsHistory,
        onOpenModal: openModal,
        getStrHist: getStrataHistory,
        getPrtDetails: getProtocolDetails
      },
      dispatch
    )
);

const MatchBox = withStyles(styles)(compose(
  withConnectState,
  withAppContext,
  withState("matchBoxFlag", "setMatchBoxFlag", false),
  withState("data", "setData", false),
  withState("state", "setState", false),
  withHandlers({
    closeMatchBox: props => event => {
      const { setState, setData, matchBoxFlag, state } = props;
      setData({ matchBoxFlag });
      setState(!state);
    },
    toggleMatchBox: props => () => {
      const { setMatchBoxFlag, matchBoxFlag, setData, isMatchboxStudy } = props;
      setMatchBoxFlag(!matchBoxFlag);
      setData(isMatchboxStudy);
    },
    cohortSync: props => () => {
      const {
        context, prtInfo, onSyncCohorts, getPrtDetails
      } = props;
      bindLogger(onSyncCohorts, context)(prtInfo.protocolNumber).subscribe(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          openSnackbar({
            message: 'Cohorts sync successful.',
            variant: 'success',
            name: 'cohorts_sync'
          });
          bindLogger(getPrtDetails, context)(prtInfo.protocolNumber);
        }
      }, err => {
        context.logError(context, err.message, err.response.error);
        bindLogger(getPrtDetails, context)(prtInfo.protocolNumber);
      });
    }
  }),
  withHandlers({
    handleChange: props => event => {
      const { setData } = props;
      setData(event.target.value);
    },
    clearMatchBoxFields: props => event => {
      const { setData, setMatchBoxFlag, isMatchboxStudy } = props;
      setData(isMatchboxStudy);
      setMatchBoxFlag(false);
    },
    saveMatchBox: props => event => {
      const {
        onSaveMatchBox, context, prtInfo, data, setMatchBoxFlag, cohortSync
      } = props;

      const confirmSave = () => {
        bindLogger(onSaveMatchBox, context)(prtInfo.prtId, 'isMatchboxStudy', data).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            setMatchBoxFlag(false);
            openSnackbar({
              message: 'Matchbox change saved successfully.',
              variant: 'success',
              name: 'match_box'
            });
            cohortSync();
          }
        });
      };
      openConfirmation({
        message: 'Do you want to save Matchbox information?',
        onAction: confirmSave,
        name: 'switch_agent'
      });
    }
  }),
  withHandlers({
    loadCohortsHistory: props => (evt, id) => {
      const { context, getCohHist } = props;
      bindLogger(getCohHist, context)(id);
    },
    loadStrataHistory: props => (evt, id) => {
      const { context, getStrHist } = props;
      bindLogger(getStrHist, context)(id);
    }
  })

)(MatchBoxInfo));


export default MatchBox;
